/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class GeradorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      listPublicacao: [],
      listPublicas: [],
      loading: true,
      loadingLiberacao: true,
      loadingPublicas: true,
      userRole: null,
      showLiberacao: false
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.acceptAction = this.acceptAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  currentGroupId = this.props?.general.active_roles.group_id;

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    // Definir userRole

    let role;
    if (this.props.user?.user_roles) {
      role = this.props.user.user_roles.find(item => item.principal === true);
    }

    // Checa se é um administrador

    const admRoles = [2, 3, 4]; // Adm de grupo, Regional e escolar, respectivamente
    if (admRoles.includes(role.role_id)) {
      this.setState({
        showLiberacao: true
      });
    }

    // Definir filtros

    const filterLiberado = {
      type: 31,
      content: true,
      user_id: this.props.user.user.id
    };

    const filterProducao = {
      type: 31,
      content: true,
      user_id: this.props.user.user.id,
      status: "Em Produção"
    };

    const filterHomologacao = {
      type: 31,
      content: true,
      user_id: this.props.user.user.id,
      status: "Em homologação"
    };

    const filterPublica = {
      type: 31,
      content: true,
      user_id: this.props.user.user.id,
      status: "Publicada"
    };

    const filterHomologar = {
      type: 31,
      content: true,
      status: "Em homologação"
    };

    const filterPublicas = {
      type: 31,
      content: true,
      status: "Publicada"
    };

    axios
      .all([
        axios.post(`${URL.api}content/los/listLosFilter`, filterLiberado, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}content/los/listLosFilter`, filterProducao, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}content/los/listLosFilter`, filterHomologacao, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}content/los/listLosFilter`, filterPublica, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(
          `${URL.api}content/los/listLosFilterGenerator`,
          filterHomologar,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        ),
        axios.post(
          `${URL.api}content/los/listLosFilterGenerator`,
          filterPublicas,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
      ])
      .then(
        axios.spread(
          (
            respLiberado,
            respProducao,
            respHomologacao,
            respPublica,
            respHomologar,
            respPublicas
          ) => {
            const respJoined = [];
            const respPublicar = [];
            const respPublicasList = [];

            if (respLiberado.data.data[0]) {
              respLiberado.data.data[0].content.forEach(item =>
                respJoined.push(item)
              );
            }

            if (respProducao.data.data[0]) {
              respProducao.data.data[0].content.forEach(item =>
                respJoined.push(item)
              );
            }

            if (respHomologacao.data.data[0]) {
              respHomologacao.data.data[0].content.forEach(item =>
                respJoined.push(item)
              );
            }

            if (respPublica.data.data[0]) {
              respPublica.data.data[0].content.forEach(item =>
                respJoined.push(item)
              );
            }

            if (respHomologar.data.data[0]) {
              respHomologar.data.data[0].content.forEach(item =>
                respPublicar.push(item)
              );
            }

            if (respPublicas.data.data[0]) {
              respPublicas.data.data[0].content.forEach(item =>
                respPublicasList.push(item)
              );
            }

            respJoined.sort((a, b) => a.id - b.id);

            // Atualizar tabela das aulas criadas pelo usuário atual
            this.atualizarListaDaTabela("list", respJoined, "loading");

            // Atualizar tabela das aulas que devem ser homologadas
            this.atualizarListaDaTabela(
              "listPublicacao",
              respPublicar,
              "loadingLiberacao"
            );

            // Atualizar tabela das aulas públicas
            const filteredPublicas = respPublicasList.filter(
              item => item.group_id === this.currentGroupId
            );

            this.atualizarListaDaTabela(
              "listPublicas",
              filteredPublicas,
              "loadingPublicas"
            );
          },
          error => {
            this.error("Não foi possível carregar os LOs");
          }
        )
      );
  }

  requisitarListaDaTabela = async (filter, estado, loadingKey) => {
    const resp = await axios.post(
      `${URL.api}content/los/listLosFilterGenerator`,
      filter,
      {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      }
    );

    let listagem = [];

    if (resp.data.data[0]) {
      resp.data.data[0].content.forEach(item => listagem.push(item));
    }
    listagem.sort((a, b) => a.id - b.id);

    if (filter.status === "Publicada") {
      listagem = listagem.filter(item => item.group_id === this.currentGroupId);
    }

    this.atualizarListaDaTabela(estado, listagem, loadingKey);
  };

  atualizarListaDaTabela = (estado, lista, loadingKey) => {
    this.setState(
      {
        [estado]: lista.length > 0 ? lista : []
      },
      () => {
        this.setState({
          [loadingKey]: false
        });
        this.state[estado].forEach(obj => this.renameKey(obj, "name", "nome"));
        this.state[estado].forEach(obj =>
          this.renameKey(obj, "resume", "descrição")
        );
      }
    );
  };

  listUpdateStatus = async (status, row) => {
    let obj = {
      status
    };

    // Atualizar o status
    const resp = await axios.post(
      `${URL.api}content/los/update/${row.id}`,
      obj,
      {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }
    );

    // Pegar a nova lista de itens para homologação
    const filterHomologar = {
      type: 31,
      content: true,
      status: "Em homologação"
    };

    this.requisitarListaDaTabela(
      filterHomologar,
      "listPublicacao",
      "loadingLiberacao"
    );

    // Se o status é para publicar, atualizar a lista de Aulas Publicadas
    if (status === "Publicada") {
      const filterPublicas = {
        type: 31,
        content: true,
        status: "Publicada"
      };

      this.requisitarListaDaTabela(
        filterPublicas,
        "listPublicas",
        "loadingPublicas"
      );
    }
  };

  renameKey = (obj, oldKey, newKey) => {
    obj[newKey] = obj[oldKey];
    // delete obj[oldKey];
  };

  insertAction = () => {
    this.props.history.push("/tools/gerador/create");
  };

  getSelected = selecteds => {
    this.setState({
      selectedQuestions: selecteds
    });
  };

  deleteAction = arrayRow => {
    for (const row of arrayRow) {
      axios
        .post(
          `${URL.api}content/los/delete/${row}`,
          {},
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            // eslint-disable-next-line react/no-access-state-in-setstate
            const list = [...this.state.list];
            const index = list.findIndex(item => item.id === row);
            list.splice(index, 1);

            this.setState({ list });
            toastr.success("Deletado", `Aula ${row} apagada.`);
          } else {
            toastr.error(
              "Falha",
              `Não foi possível apagar a aula de ID ${row}.`
            );
          }
        })
        .catch(err => {
          toastr.error("Falha", `Não foi possível apagar a aula de ID ${row}.`);
        });
    }
  };

  acceptAction = row => {
    this.listUpdateStatus("Publicada", row);
  };

  render() {
    return (
      <>
        {this.state.showLiberacao && (
          <div className="animated fadeIn">
            {this.state.loadingLiberacao ? (
              <Loading top="45" left="50" />
            ) : (
              <Row>
                <Breadcrumb current={this.props.currentRoute} />
                {this.state.listPublicacao ? (
                  <div id="list">
                    <DataTable
                      list={this.state.listPublicacao}
                      path="/tools/gerador/show/"
                      viewPath="/content/view/"
                      viewQuery={row => `?title=${row.name}`}
                      viewBlank
                      title="Liberar Aulas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "nome", denomination: "Nome" },
                        { name: "status", denomination: "Status" },
                        { name: "descrição", denomination: "Descrição" }
                      ]}
                      insertAction={this.insertAction}
                      getSelected={this.getSelected}
                      action
                      btnEdit
                      btnView
                      deleteAction={this.deleteAction}
                      btnAccept
                      acceptAction={this.acceptAction}
                      btnDecline
                      listUpdateStatus={this.listUpdateStatus}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </Row>
            )}
          </div>
        )}
        {this.state.loading && this.state.loadingPublicas ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            <div className="animated fadeIn">
              <Row>
                {this.state.list ? (
                  <div id="list">
                    <DataTable
                      list={this.state.list}
                      path="/tools/gerador/show/"
                      // path="/tools/gerador/edit/"
                      viewPath="/content/view/"
                      viewQuery={row => `?title=${row.name}`}
                      viewBlank
                      title="Aulas Geradas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "nome", denomination: "Nome" },
                        { name: "status", denomination: "Status" },
                        { name: "descrição", denomination: "Descrição" }
                      ]}
                      insert
                      delete
                      insertAction={this.insertAction}
                      getSelected={this.getSelected}
                      action
                      btnEdit
                      btnView
                      deleteAction={this.deleteAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </Row>
            </div>
            <div id="listPublica" className="animated fadeIn">
              <Row>
                {this.state.listPublicas ? (
                  <div id="list">
                    <DataTable
                      list={this.state.listPublicas}
                      path="/tools/gerador/show/"
                      viewPath="/content/view/"
                      viewQuery={row => `?title=${row.name}`}
                      viewBlank
                      title="Aulas Públicas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "nome", denomination: "Nome" },
                        { name: "status", denomination: "Status" },
                        { name: "descrição", denomination: "Descrição" }
                      ]}
                      insertAction={this.insertAction}
                      getSelected={this.getSelected}
                      action
                      btnEdit
                      btnView
                      deleteAction={this.deleteAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </Row>
            </div>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

GeradorList.propTypes = {
  // hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

GeradorList.defaultProps = {
  // hideLayout: true,
  guestLogin: false
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GeradorList);
